export default {
  download_list: 'Download List',
  upload_store: 'Upload Store',
  reference_detail: 'Reference Detail',
  submid: 'SUBMID',
  store_name: 'Store Name',
  store_address: 'Store Address',
  business_line: 'Business Line',
  register_no: 'register No.',
  dti_sec_register_no: 'DTI/SEC register No.',
  bank_ewallet_name: 'Bank/Ewallet Name',
  account_holder_name: 'Account Holder Name',
  bank_ewallet_no: 'Bank/Ewallet  No.',
  download_qr: 'Download QR',
  upload_store_attachments: 'Upload store attachments',
  qr_stand: 'QR Stand',
  qr_stand_id: 'QR Stand ID',
  receipt: 'Receipt',
  edit_remark: 'Edit remark'
}
